export default function Close({ className = "" }) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.0002 13.1213L19.839 21.9601L21.6068 20.1924L12.768 11.3535L21.9604 2.16116L20.1926 0.393393L11.0002 9.58577L1.80781 0.393372L0.0400391 2.16114L9.23244 11.3535L0.393595 20.1924L2.16136 21.9601L11.0002 13.1213Z" fill="currentColor"/>
    </svg>
  )
}